<template>
    <div style="display: inline-block;">
        <div class="icon-container">
            <div v-for="(iconSet, setIndex) in iconSets" :key="setIndex" class="icon-set">
                <svg xmlns="http://www.w3.org/2000/svg"
                     width="1em"
                     height="1em"
                     viewBox="0 0 24 24"
                     class="icon-svg"
                     @mouseover="hoverIcon(setIndex, 0)"
                     @mouseleave="resetHoveredIcon(setIndex, 0)"
                     @click="toggleIcon(setIndex, 0)">
                    <path :fill="getFill(setIndex, 0)"
                          :d="getIconPath(setIndex, 0)"></path>
                </svg>
                <div class="iconName">{{$t(iconSet.name)}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: Number
        },
        data() {
            return {
                hoveredIcon: null,
                lastClickedIcon: null,
                hoverColor: '',
                iconSets: [
                    {
                        id: 1,
                        name: 'Terrible',
                        icons: [
                            {
                                color: '#d22427',
                                currentColor: '#1B8354',
                                clicked: false,
                                outlinePath: 'M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 18a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8m0-6c1.75 0 3.29.72 4.19 1.81l-1.42 1.42C14.32 16.5 13.25 16 12 16s-2.32.5-2.77 1.23l-1.42-1.42C8.71 14.72 10.25 14 12 14m-2-4.5c0 .8-.7 1.5-1.5 1.5S7 10.3 7 9.5V8zm7 0c0 .8-.7 1.5-1.5 1.5S14 10.3 14 9.5L17 8z',
                                originalOutlinePath: 'M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m0 18a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8m0-6c1.75 0 3.29.72 4.19 1.81l-1.42 1.42C14.32 16.5 13.25 16 12 16s-2.32.5-2.77 1.23l-1.42-1.42C8.71 14.72 10.25 14 12 14m-2-4.5c0 .8-.7 1.5-1.5 1.5S7 10.3 7 9.5V8zm7 0c0 .8-.7 1.5-1.5 1.5S14 10.3 14 9.5L17 8z',
                                inlinePath: 'M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2M7 9.5V8l3 1.5c0 .8-.7 1.5-1.5 1.5S7 10.3 7 9.5m7.77 7.73C14.32 16.5 13.25 16 12 16s-2.32.5-2.77 1.23l-1.42-1.42C8.71 14.72 10.25 14 12 14c1.75 0 3.29.72 4.19 1.81zM17 9.5c0 .8-.7 1.5-1.5 1.5S14 10.3 14 9.5L17 8z'
                            },
                        ],
                    },
                    {
                        id: 2,
                        name: 'Bad',
                        icons: [
                            {
                                color: '#e36024',
                                currentColor: '#1B8354',
                                clicked: false,
                                inlinePath: 'M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2M7 9.5C7 8.7 7.7 8 8.5 8s1.5.7 1.5 1.5S9.3 11 8.5 11S7 10.3 7 9.5m7.77 7.73C14.32 16.5 13.25 16 12 16s-2.32.5-2.77 1.23l-1.42-1.42C8.71 14.72 10.25 14 12 14c1.75 0 3.29.72 4.19 1.81zM15.5 11c-.8 0-1.5-.7-1.5-1.5S14.7 8 15.5 8s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5',
                                outlinePath: 'M20 12a8 8 0 0 0-8-8a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8m2 0a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10m-6.5-4c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5M10 9.5c0 .8-.7 1.5-1.5 1.5S7 10.3 7 9.5S7.7 8 8.5 8s1.5.7 1.5 1.5m2 4.5c1.75 0 3.29.72 4.19 1.81l-1.42 1.42C14.32 16.5 13.25 16 12 16s-2.32.5-2.77 1.23l-1.42-1.42C8.71 14.72 10.25 14 12 14',
                                originalOutlinePath: 'M20 12a8 8 0 0 0-8-8a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8m2 0a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10m-6.5-4c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5M10 9.5c0 .8-.7 1.5-1.5 1.5S7 10.3 7 9.5S7.7 8 8.5 8s1.5.7 1.5 1.5m2 4.5c1.75 0 3.29.72 4.19 1.81l-1.42 1.42C14.32 16.5 13.25 16 12 16s-2.32.5-2.77 1.23l-1.42-1.42C8.71 14.72 10.25 14 12 14'
                            },
                        ],
                    },
                    {
                        id: 3,
                        name: 'Okay',
                        icons: [
                            {
                                color: '#e39236',
                                currentColor: '#1B8354',
                                clicked: false,
                                inlinePath: 'M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2M8.5 8A1.5 1.5 0 1 1 7 9.5A1.54 1.54 0 0 1 8.5 8m8.5 8h-4a4 4 0 0 0-3.47 2L7.8 17a6 6 0 0 1 5.2-3h4m-1.5-3A1.5 1.5 0 1 1 17 9.5a1.54 1.54 0 0 1-1.5 1.5',
                                outlinePath: 'M20 12a8 8 0 1 0-8 8a8 8 0 0 0 8-8m2 0A10 10 0 1 1 12 2a10 10 0 0 1 10 10m-6.5-4A1.5 1.5 0 1 1 14 9.5A1.54 1.54 0 0 1 15.5 8M10 9.5A1.5 1.5 0 1 1 8.5 8A1.54 1.54 0 0 1 10 9.5m7 5.5h-4a4 4 0 0 0-3.47 2L7.8 16a6 6 0 0 1 5.2-3h4Z',
                                originalOutlinePath: 'M20 12a8 8 0 1 0-8 8a8 8 0 0 0 8-8m2 0A10 10 0 1 1 12 2a10 10 0 0 1 10 10m-6.5-4A1.5 1.5 0 1 1 14 9.5A1.54 1.54 0 0 1 15.5 8M10 9.5A1.5 1.5 0 1 1 8.5 8A1.54 1.54 0 0 1 10 9.5m7 5.5h-4a4 4 0 0 0-3.47 2L7.8 16a6 6 0 0 1 5.2-3h4Z'
                            },
                        ],
                    },
                    {
                        id: 4,
                        name: 'Good',
                        nameAr: '',
                        icons: [
                            {
                                color: '#e9ca1d',
                                currentColor: '#1B8354',
                                clicked: false,
                                inlinePath: 'M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2M7 9.5C7 8.7 7.7 8 8.5 8s1.5.7 1.5 1.5S9.3 11 8.5 11S7 10.3 7 9.5m5 7.73c-1.75 0-3.29-.73-4.19-1.81L9.23 14c.45.72 1.52 1.23 2.77 1.23s2.32-.51 2.77-1.23l1.42 1.42c-.9 1.08-2.44 1.81-4.19 1.81M15.5 11c-.8 0-1.5-.7-1.5-1.5S14.7 8 15.5 8s1.5.7 1.5 1.5s-.7 1.5-1.5 1.5',
                                outlinePath: 'M20 12a8 8 0 0 0-8-8a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8m2 0a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10M10 9.5c0 .8-.7 1.5-1.5 1.5S7 10.3 7 9.5S7.7 8 8.5 8s1.5.7 1.5 1.5m7 0c0 .8-.7 1.5-1.5 1.5S14 10.3 14 9.5S14.7 8 15.5 8s1.5.7 1.5 1.5m-5 7.73c-1.75 0-3.29-.73-4.19-1.81L9.23 14c.45.72 1.52 1.23 2.77 1.23s2.32-.51 2.77-1.23l1.42 1.42c-.9 1.08-2.44 1.81-4.19 1.81',
                                originalOutlinePath: 'M20 12a8 8 0 0 0-8-8a8 8 0 0 0-8 8a8 8 0 0 0 8 8a8 8 0 0 0 8-8m2 0a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10M10 9.5c0 .8-.7 1.5-1.5 1.5S7 10.3 7 9.5S7.7 8 8.5 8s1.5.7 1.5 1.5m7 0c0 .8-.7 1.5-1.5 1.5S14 10.3 14 9.5S14.7 8 15.5 8s1.5.7 1.5 1.5m-5 7.73c-1.75 0-3.29-.73-4.19-1.81L9.23 14c.45.72 1.52 1.23 2.77 1.23s2.32-.51 2.77-1.23l1.42 1.42c-.9 1.08-2.44 1.81-4.19 1.81'
                            },
                        ],
                    },
                    {
                        id: 5,
                        name: 'Great',
                        icons: [
                            {
                                color: '#05ac50',
                                currentColor: '#1B8354',
                                clicked: false,
                                inlinePath: 'M12 2C6.47 2 2 6.5 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m3.5 6A1.5 1.5 0 0 1 17 9.5a1.5 1.5 0 0 1-1.5 1.5A1.5 1.5 0 0 1 14 9.5A1.5 1.5 0 0 1 15.5 8m-7 0A1.5 1.5 0 0 1 10 9.5A1.5 1.5 0 0 1 8.5 11A1.5 1.5 0 0 1 7 9.5A1.5 1.5 0 0 1 8.5 8m3.5 9.5c-2.33 0-4.31-1.46-5.11-3.5h10.22c-.81 2.04-2.78 3.5-5.11 3.5',
                                outlinePath: 'M12 17.5c2.33 0 4.3-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5M8.5 11A1.5 1.5 0 0 0 10 9.5A1.5 1.5 0 0 0 8.5 8A1.5 1.5 0 0 0 7 9.5A1.5 1.5 0 0 0 8.5 11m7 0A1.5 1.5 0 0 0 17 9.5A1.5 1.5 0 0 0 15.5 8A1.5 1.5 0 0 0 14 9.5a1.5 1.5 0 0 0 1.5 1.5M12 20a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8m0-18C6.47 2 2 6.5 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2',
                                originalOutlinePath: 'M12 17.5c2.33 0 4.3-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5M8.5 11A1.5 1.5 0 0 0 10 9.5A1.5 1.5 0 0 0 8.5 8A1.5 1.5 0 0 0 7 9.5A1.5 1.5 0 0 0 8.5 11m7 0A1.5 1.5 0 0 0 17 9.5A1.5 1.5 0 0 0 15.5 8A1.5 1.5 0 0 0 14 9.5a1.5 1.5 0 0 0 1.5 1.5M12 20a8 8 0 0 1-8-8a8 8 0 0 1 8-8a8 8 0 0 1 8 8a8 8 0 0 1-8 8m0-18C6.47 2 2 6.5 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2'
                            },
                        ],
                    }
                ],
            }
        },
        computed: {
            modelValue: {
                get() {
                    return this.value
                },
                set(val) {
                    this.$emit('input', val)
                }
            }
        },
        watch:{           

        },
        methods: {
            
            getIconPath(setIndex, iconIndex) {
                const icon = this.iconSets[setIndex].icons[iconIndex]
                return icon.isClicked ? icon.inlinePath : icon.outlinePath
            },
            getFill(setIndex, iconIndex) {
                if (this.hoveredIcon === `${setIndex}-${iconIndex}`) {
                   
                    return this.iconSets[setIndex].icons[iconIndex].color
                } else {
                    if (this.lastClickedIcon !== null && this.lastClickedIcon[0].clicked === true && this.lastClickedIcon[0].inlinePath === this.iconSets[setIndex].icons[iconIndex].inlinePath) {
                        
                        return this.iconSets[setIndex].icons[iconIndex].color = this.lastClickedIcon[0].color
                    } else {
                     
                      return this.iconSets[setIndex].icons[iconIndex].currentColor
                    }
                    
                }
            },
            hoverIcon(setIndex, iconIndex) {
                const icon = this.iconSets[setIndex].icons[iconIndex]

                if (!icon.clicked || (this.lastClickedIcon !== null && this.lastClickedIcon !== setIndex)) {

                    this.hoveredIcon = `${setIndex}-${iconIndex}`
                }
                if (this.lastClickedIcon !== null) {
                    for (let i = 0; i < this.iconSets.length; i++) {
                        if (this.iconSets[i].icons[0].inlinePath === this.lastClickedIcon[0].inlinePath) {
                            this.iconSets[i].icons[0].color = this.lastClickedIcon[0].color
                        }
                    }
                }
            },
            resetHoveredIcon(setIndex, iconIndex) {

                const icon = this.iconSets[setIndex].icons[iconIndex]
                if (icon.clicked) {
                    this.hoveredIcon = `${setIndex}-${iconIndex}`
                } else {
                    this.hoveredIcon = null//`${setIndex}-${iconIndex}`
                }
            },
            toggleIcon(setIndex, iconIndex) {
                const icons = this.iconSets[setIndex].icons

                
                const icon = icons[iconIndex]
                if (icon.clicked) {
                    icon.outlinePath = icon.inlinePath
                } else {
                    
                    if (!icon.originalOutlinePath) {
                        icon.originalOutlinePath = icon.outlinePath
                    }
                    icon.outlinePath = icon.inlinePath
                }
                icon.clicked = !icon.clicked
                this.lastClickedIcon = icons

                for (let i = 0; i < this.iconSets.length; i++) {
                    if (i !== setIndex) {
                        this.iconSets[i].icons[0].outlinePath = this.iconSets[i].icons[0].originalOutlinePath
                        this.iconSets[i].icons[0].clicked = false
                    }
                }
                this.$emit('input', this.iconSets[setIndex].id)
            },
        },
    }
</script>

<style>
    .icon-set {
        margin-bottom: 10px;
        margin-right:7px;
    }
    .iconName {
        font-weight: 700;
        color: #1B8354;
        text-align: center;
    }
    .icon {
        display: inline-block;
        margin-right: 10px;
    }

    .icon-svg {
        width: 50px;
        height: 50px;
        transition: fill 0.3s;
    }

    .icon-container {
        display: flex;
        margin-bottom: 10px;
    }
</style>
